import { Component, OnInit, Input } from '@angular/core';
//import speaker from '../../../data/speaker.json';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-speaker',
  templateUrl: './speaker.component.html',
  styleUrls: ['./speaker.component.css']
})
export class SpeakerComponent implements OnInit {

  constructor(private httpClient: HttpClient) { }
  public speaker:any = [];
  public speakerData:any = [];
  @Input() value:any[] =[];
  ngOnInit(): void {

   this.fetchdata()  ;
  }
  fetchdata()   
  {  
    this.httpClient.get('/api/trainingspeakers').subscribe(
      data=>{
        this.speakerData = data;

        if(this.value.length>0)
        {
        this.speaker = this.speakerData.filter((speak: { id: string; }|any) => this.value.findIndex((val)=> speak.id==val)>=0);
        }
        else{
          this.speaker = this.speakerData;
        }
      }
    );
  }
}
